import { render, staticRenderFns } from "./DeputyDialog.vue?vue&type=template&id=c249375c"
import script from "./DeputyDialog.vue?vue&type=script&lang=js"
export * from "./DeputyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports